module.exports = __webpack_public_path__ + "media/images/iconUp-52d96009928c249cdc31316b2ba5fc77.png";